import CandidateJobs from './CandidateJobs.container';

export default CandidateJobs;
